<template>
    <div v-wechat-title="title" class="padding10">
        <crud-facecade ref="used-blood-list" :url="url" :columns="columnList" :buttons="[]" :tableHeight="screenHeight - 190" :addButton="{ enabled: false }" :updateButton="{ enabled: false }">
            <template slot="filter">
                <el-col :md="9" :lg="7" :xl="5">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :md="5" :lg="4" :xl="3">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
            </template>
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="print">打印</el-button>
            </template>
        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `BloodQuery`,
    props: {},
    data() {
        return {
            title: `输血查询`,
            o_dic_operating_ward_id: undefined,
            issetoperatingward: false,
            // surgeryId:this.$route.query.surgery_id,
            rdate: [
                this.$moment()
                    .add(-7, `days`)
                    .format(`YYYY/MM/DD HH:mm:ss`),
                this.$moment()
                    .add(1, `days`)
                    .format(`YYYY/MM/DD HH:mm:ss`)
            ],
            usedBloodRecords: [],
            url: {
                area: `BloodQuery`,
                baseURL: ``,
                get: () => {
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.get(`/api/Nursing/Blood/GetBloodDetails?from=${this.rdate[0]}&to=${this.rdate[1]}`)
                        req.then(data => {
                            if (this.dic_operating_ward_id) {
                                data = _.filter(data, { dic_operating_ward_id: this.dic_operating_ward_id })
                            }
                            let r =
                                data &&
                                data.map((d, index) => {
                                    d.___index = `${d.biz_blood_header_id}_${d.id}`
                                    d.circuit = d.circuit && d.circuit.name
                                    d.anesthesiologist = d.anesthesiologist && d.anesthesiologist.name
                                    d.quantity = `${d.blood.name} ${d.quantity}${d.blood.unit}`
                                    d.use_blood_type = `${d.blood_type || `--`}(${d.blood_type_rh || `--`})`
                                    // d.blood_name = d.blood.name
                                    return d
                                })
                            this.usedBloodRecords = r
                            // console.log(r)
                            resolve(r)
                        }).catch(e => reject(e))
                    })
                }
            }
        }
    },
    mounted() {
        // this.Init()
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
    },
    computed: {
        ...mapGetters([`sys_enums`, `operation_ward_auth`, `active_ward`, `screenHeight`]),
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `___index`,
                    label: `___index`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `biz_blood_header_id`,
                    label: `biz_blood_header_id`
                },
                {
                    type: `string`,
                    prop: `dic_blood_id`,
                    label: `dic_blood_id`
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `姓名`,
                    isListable: true,
                    searchable: true,
                    width: `100`
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`blood_query.visit_no`),
                    width: `80`,
                    searchable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `use_blood_type`,
                    label: `病人血型`,
                    width: `80`,
                    searchable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_operating_ward`,
                    label: `手术区 `,
                    width: `90`,
                    searchable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    width: `80`,
                    searchable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `quantity`,
                    label: `输血量`,
                    // width:"200",
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `isOwn`,
                    label: `是否自体血`,
                    width: `80`,
                    isListable: true,
                    searchable: true,
                    options: `enum_bool`
                },
                {
                    type: `string`,
                    prop: `using_blood_status`,
                    label: `输血状态`,
                    width: `60`,
                    searchable: true,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `begin_time`,
                    label: `输血开始`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `end_time`,
                    label: `输血结束`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `circuit`,
                    label: `输血护士`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anesthesiologist`,
                    label: `输血医生`,
                    width: `100`,
                    isListable: true
                }
            ]
        }
    },
    methods: {
        print() {
            // console.log(this.usedBloodRecords)
            let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req2.then(isShow => {
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: Object.assign(
                        {
                            docid: this.$root.DOCUMENT.SX011,
                            id1: ``,
                            objId: this.usedBloodRecords.map(d => d.id).toString()
                        },
                        { isShowSendPrintMessage: isShow.value }
                    )
                })
            }).catch(e => {
                console.log(e)
            })
        }
    },
    watch: {
        rdate: function() {
            this.$refs[`used-blood-list`].ReloadListData()
        },
        dic_operating_ward_id: function() {
            this.$refs[`used-blood-list`].ReloadListData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Surgery/Blood/Query.vue